<div class="calendarDs__cont" *ngIf="month">
  <app-ds-background-surface
    class="calendarDs__anchor {{month.anchor}}"
    [width]="'366px'"
    [height]="'auto'"
    [padding]="'var(--spacing-nano)'">
    <div class="calendarDs__cont__month">
      <app-ds-typography
        class="month-name"
        [text]="month.name | titlecase"
        [fontFamily]="fontFamilySemiBold"
        [size]="primarySize">
      </app-ds-typography>
      <app-ds-typography
        class="year"
        [text]="month.year"
        [fontFamily]="fontFamilyRegular"
        [size]="primarySize">
      </app-ds-typography>
    </div>
    <div class="calendarDs__cont__weekdays">
      <ng-container *ngFor="let weekday of month.weekdays">
        <div class="calendarDs__cont__weekdays__weekday">
          <app-ds-typography
            [text]="weekday"
            [fontFamily]="fontFamilyRegular"
            [size]="weekDaySize">
          </app-ds-typography>
        </div>
      </ng-container>
    </div>
    <div class="calendarDs__cont__days">
      <div class="calendarDs__cont__days__row" *ngFor="let row of month.grid">
        <ng-container *ngFor="let day of row">
          <app-ds-background-surface
            [width]="'50px'"
            [height]="'50px'">
            <div class="day-cont">
              <div class="day {{day.type}}"
                [class.visible]="day.visible"
                [class.today]="day.isToday"
                [class.disabled]="day.disabled"
                [class.selected]="day.selected"
                [class.in-range]="day.dayInRange"
                [class.in-range-right]="day.dayInRangeRight"
                [class.in-range-left]="day.dayInRangeLeft"
                (click)="clickEventTrigger(day)">
                <app-ds-typography
                  [text]="day.value"
                  [fontFamily]="dayFontWeight(day)"
                  [size]="primarySize">
                </app-ds-typography>
              </div>
            </div>
          </app-ds-background-surface>
        </ng-container>
      </div>
    </div>
  </app-ds-background-surface>
</div>